import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-mb-md order-num" }
const _hoisted_2 = { class: "q-ml-md" }

import { computed } from 'vue';

interface Props {
  // ダイアログを表示するかどうか
  display: boolean;
  // 問い合わせ番号
  quotationNo: string;
  // ボタン名
  btnName: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'QuotationSuccessDialog',
  props: {
    display: { type: Boolean },
    quotationNo: {},
    btnName: {}
  },
  emits: ["ok"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const dialog = computed(() => props.display);

const emit = __emit;

const ok = () => {
  emit('ok');
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    persistent: "",
    class: "order-quotation-dialog quotation-success-dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, { class: "information" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_avatar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, { name: "mdi-alert-circle" })
                ]),
                _: 1
              }),
              _createVNode(_component_q_toolbar_title, { class: "text-weight-bold" }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("お問い合わせ完了")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "order-title" }, "お問い合わせ番号", -1)),
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.quotationNo), 1)
                ])
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "q-mb-sm" }, "お問い合わせ内容をメールで送信いたしましたので、ご確認ください。", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "q-mb-xs" }, [
                _createTextVNode(" お問い合わせ完了メールが届かない場合は、メールの送受信に不具合がある可能性がございますので、"),
                _createElementVNode("br"),
                _createTextVNode("お手数ですが、お電話にて下記までお問い合わせください。"),
                _createElementVNode("br")
              ], -1)),
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "q-mb-none" }, "TEL: 03-6262-6467", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, {
            align: "center",
            class: "btn-area"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                color: "primary",
                label: _ctx.btnName,
                style: {"width":"220px"},
                onClick: ok
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})